import { CaretDown, CaretUp } from "@phosphor-icons/react";
import Button from "./Button";
import DropdownMenu from "./DropdownMenu";
import FormRadioInput from "./FormRadioInput";

export type SingleSelectDropdownItemOption<T> = {
    label: string;
    value: T;
};

type SingleSelectDropdownProps<T> = {
    label: string;
    selected: T;
    options: SingleSelectDropdownItemOption<T>[];
    name: string;
    onSelect: (value: T) => void;
    onReset: () => void;
};

const SingleSelectDropdown = <T,>({
    label,
    selected,
    options,
    name,
    onSelect,
    onReset,
}: SingleSelectDropdownProps<T>) => {
    return (
        <DropdownMenu.Container>
            <DropdownMenu.Trigger>
                {({ open }) => (
                    <div className="flex items-center">
                        {label}
                        <span className="ml-2">
                            {open ? (
                                <CaretUp weight="bold" />
                            ) : (
                                <CaretDown weight="bold" />
                            )}
                        </span>
                    </div>
                )}
            </DropdownMenu.Trigger>
            <DropdownMenu.Items>
                <div className="max-h-[15.5rem] overflow-y-auto py-1 w-[300px]">
                    {options.map((option) => (
                        <div className="px-3 py-1" key={`${option.value}`}>
                            <FormRadioInput
                                id={`radio-input-${option.value}`}
                                name={name}
                                checked={selected === option.value}
                                label={option.label}
                                onChange={() => onSelect(option.value)}
                            />
                        </div>
                    ))}
                </div>
                <div className="p-3 border-t">
                    <Button
                        variant="outline"
                        className="w-full"
                        onClick={onReset}
                    >
                        Reset filter
                    </Button>
                </div>
            </DropdownMenu.Items>
        </DropdownMenu.Container>
    );
};

export default SingleSelectDropdown;
